/**
 @ngdoc service
 @name helperFactory

 @description
 This factory is created to bypass some Angular expressions limitations ie. that we cannot run angular.functions.<br />
 It's bound to main Angular controller as angularHelper

 @usage
 in the template:
 angularHelper.copyByVal etc.
 */
angular.module('app').factory('helperFactory', function() {

    var debug = function(msg){
        console.info(msg);
    }

    /**
     * @ngdoc method
     * @name copyByVal
     * @methodOf helperFactory
     * @param {Array} src source array
     * @description
     * Normally Angular copies Objects or Array by reference - this method allows copy by value (src can be any type, created for objects and arrays)
     * @returns {Object|Array} Object or Array copied by value.
     */
    var copyByVal = function(src){
        return angular.copy(src);
    }

    /**
     * @ngdoc method
     * @name mergeArraysUnique
     * @methodOf helperFactory
     * @param {Array} array1 array1
     * @param {Array} array2 array1
     * @param {string} uniqueProp unique property
     * @param {Boolean} debugIt console output the calls TODO: IE11 death include default debugIt
     *
     * @description
     * Merges two arrays of objects (explicitely for commsCentre tagsInput)<br/>
     * will prevent creation of uniqueProp
     */
    var mergeArraysUnique = function(array1, array2, uniqueProp, debugIt){
        if (debugIt) console.log('helperFactory.mergeArraysUnique()', {array1: array1, array2: array2, uniqueProp: uniqueProp});
        var result = angular.copy(array1);
        angular.forEach( array2, function(val) {
            if ( !result.filter(function(el) { return el[uniqueProp] === val[uniqueProp]; }).length > 0 ) {
                // if only doesn't contain already given val (compares xmsId)
                result.push(val);
            }
        });
        return result;
    }

    /**
     * @ngdoc method
     * @name removeFromArray
     * @methodOf helperFactory
     * @param {Array} array array
     * @param {any} el array element to be removed
     * @description
     * removes el from array
     */
    var removeFromArray = function(array, el){
        var index = array.indexOf(el);
        if (index > -1) {
            array.splice(index, 1);
        }
        return array;
    }

    /**
     * @ngdoc method
     * @name countProps
     * @methodOf helperFactory
     * @param {Object} objArray objArray
     * @param {any} comparators see description
     * @description
     * counts how many elements with given properties (comparators) the given object array contains<br />
     * comparators (Object) ie. {'recipientStatus':'valid', 'isList':'false'}<br />
     * used for counting valid recipients in Comms Centre
     */
    var countProps = function(objsArray, comparators){
        var result = 0;
        angular.forEach(objsArray, function(val){
            var valid = true;
            angular.forEach(comparators, function(comparator, prop){
                if(val[prop]!=comparator){
                    valid = false;
                }
            });
            if(valid){
                result++;
            }
        });
        return result;
    }

    /**
     * @ngdoc method
     * @name countProp
     * @methodOf helperFactory
     * @param {Object} objArray objArray
     * @param {any} comparators see description
     * @description
     * counts how many properties equal to comparator the given object array contains<br />
     * comparators (Object) ie. true / false / 121
     * used to count tabs loaded in item template
     */
    var countProp = function(objArray, comparator){
        var result = 0;
        angular.forEach(objArray, function(val){
            if(val==comparator){
                result++;
            }
        });
        return result;
    }

    /**
     * @ngdoc method
     * @name newDate
     * @methodOf helperFactory
     * @param {Date} date date object
     * @description
     * returns date object from string (you need to convert all json date strings into object if you want to initialize date pickers)<br />
     * ncludes timezone fix
     */
    var newDate = function(date){
        return new Date(date.replace(/-/g, '/')); // timezone fix
    }

    /**
     * @ngdoc method
     * @name copyListFieldWithValue
     * @methodOf helperFactory
     * @param {Array} list array
     * @param {String} fieldName (fieldName of the field to be set)
     * @param {Object} value (object to copy to the field)
     * @param {Boolean} debugIt console output the calls TODO: IE11 death include default debugIt
     * @description
     * this will iterate each element of the list and set the field(indicate with fieldName) with value.
     */
    var copyListFieldWithValue = function (list, fieldName, value, debugIt ){
        if (debugIt) console.log('helperFactory.copyListFieldWithValue', {fieldName: fieldName});

        angular.forEach( list, function(element) {
            element[fieldName] = value;
        });
    }
    
    /**
     * @ngdoc method
     * @name dateAddSubtractDays
     * @methodOf helperFactory
     * @param {Date} date date object
     * @param {Number} days (can be negative ie. -5)
     * @description
     * adds or subtracts (for negative days) given number of days to / from date
     */
    var dateAddSubtractDays = function(date, days){
        return date.setDate(date.getDate()+days);
    }

    var roundNumberDown = function(number) {
        return Math.floor(number);
    }

    var roundNumber = function(number, multiplier) {
        return Math.round(number * multiplier) / multiplier;
    }

    //@param {Boolean} debugIt console output the calls TODO: IE11 death include default debugIt
    var filterList = function (list, string, key, debugIt){
        if (debugIt) console.log('helperFactory.filterList()', {list: list, string: string, key: key});
        if (!string) {
            return list
        }
        var myString = string.toLowerCase().trim();
        if (!myString) {
            return list
        }
        return list.filter( function(element){
            return element[key].toLowerCase().indexOf( myString ) > -1
        })
    }

    var getCostCodes = function(object){
        var lookupIds = [];
        for (var key in object) {
            var element = object[key]
            
            lookupIds.push(element.costCodeIdForLookup);
        }
        return lookupIds.join(',');
    }

    var reduceList = function(list, comparator, key) {
        if(!comparator){
            return list
        }
        return list.reduce(reducer)
        function reducer(output,element) {
            return element[key] === comparator ? element : output
        }
    }
    var validateCostCode2 = function(object){
        var lookupIds = [];
        var isMandatory = false;
        for (var key in object) {
            var element = object[key]
            if(element.costCodeValue != null && "A1Z0000" === element.costCodeValue){
                isMandatory = true;
                break;
            }
        }
        return isMandatory;
    }

    var getElementArrayLength = function (element) {    
        return $(element).length
    }
    
    var triggerElementEvent = function (elementId,  eventName) {
        $(elementId).trigger(eventName)
    }

    var getObjectPropertiesLength = function (object) {
        if(!object)return;
        var keys = Object.keys(object)
        keys = keys.filter(function (key) { return object[key] !== undefined})
        return keys.length;
    }

    var joinObjectProperties = function (object1, object2) {
        return Object.assign(object1, object2)
    }

    var cloneDeep = function(obj) {
        return JSON.parse(JSON.stringify(obj))
    }

    var joinObjectPropertiesClone = function (object1, object2) {
        var result = Object.assign(object1, object2)
        return cloneDeep(result)
    }

    var removePropertiesOfObjectFromAnother = function(propertiesToRemove, targetObject) {
        for (var key in propertiesToRemove) {
            if(!targetObject[key]) return;
            delete targetObject[key];
        }
        return targetObject;
    }

    var hasValue = function(object){
        var hasValue = false;
        if(object != null) {
            for (var key in object) {
                var element = object[key]
                if (element === true) {
                    hasValue = true;
                    break;
                }
            }
        }
        return hasValue;
    }

    var allValuesSelected = function(selectedValues, totalPossible){
        if(!selectedValues || Object.keys(selectedValues).length < totalPossible)
            return false

        for(var key in selectedValues) {
            if(selectedValues[key] === false){
                return false;
            }
        }
        return true;
    }

    var encodeURLComponent = function(object) {
        return encodeURIComponent(object);
    }

    /**
     * @ngdoc method
     * @name setAllValuesForGivenProperty
     * @methodOf helperFactory
     * @param {Array} arrayOrObject An array or Object to alter
     * @param {String} propertyKey The property key to be altered
     * @param {Object} propertyValue The property value to set
     * @param {Boolean} debugIt console output the calls TODO: IE11 death include default debugIt
     * @description
     * Similar to Collections.collect in Java filter list down to only desired elements
     */
    var setAllValuesForGivenProperty = function (arrayOrObject, propertyKey, propertyValue, debugIt) {
        var convertedArray;
        var isArray = Array.isArray(arrayOrObject);
        //TODO: IE11 death switch to literal { arrayOrObject, propertyKey, propertyValue, isArray }
        var debugLiteral = {
            arrayOrObject: arrayOrObject,
            propertyKey: propertyKey,
            propertyValue: propertyValue,
            isArray: isArray
        }
        if (debugIt) console.log('helperFactory.setAllValuesForGivenProperty()', debugLiteral);
        if (arrayOrObject && propertyKey && propertyValue !== undefined) {
            convertedArray = isArray ? arrayOrObject : Object.entries(arrayOrObject);
            convertedArray = convertedArray.map(function (obj) {
                obj[propertyKey]=propertyValue;
                return obj;
            });
        } else {
            const errorMsg = 'helperFactory.setAllValuesForGivenProperty() has an undefined argument';
            console.error(errorMsg, debugLiteral);
            throw new Error(errorMsg);
        }
        return convertedArray
    }

    //
    /**
     *
     * @param dataList example [{"value": 123,"checked": false}, {"value": 531,"checked": true}]
     * @param propertyKeyAndValue example {value:531, checked:true}
     * @param debugIt
     * @returns {boolean}
     */
    var someForAllGivenProperties = function (dataList, propertyKeyAndValue, debugIt) {
        //TODO: IE11 death switch to literal { dataList, propertyKeyAndValueList }
        if (debugIt) console.log('helperFactory.someForAllGivenProperties()',
            {dataList: dataList, propertyKeyAndValueList: propertyKeyAndValue});
        var found;

        if (Array.isArray(dataList) && typeof propertyKeyAndValue === 'object') {
            for(var propertyKey in propertyKeyAndValue){
                var propertyValue = propertyKeyAndValue[propertyKey];
                if (debugIt) console.log('helperFactory.someForAllGivenProperties()',{found: found, propertyKey: propertyKey, propertyValue: propertyValue} );
                //IF found not set OR found was false THEN desired propertyKeyAndValue have not been met
                if(found===undefined || !found ) {
                    //IF the property key in the array object exists and is the desired value THEN true ELSE false
                    found = dataList.some(function (obj) {
                        var objectValue = obj[propertyKey];
                        if (debugIt) console.log('helperFactory.someForAllGivenProperties()',{objectValue: objectValue, propertyValue: propertyValue} );
                        return objectValue === propertyValue;
                    });
                }
            }
        } else {
            found = false;
        }
        return found;
    }

    var timeout = function (callBack, time, debugIt) {
         console.log('helperFactory.timeout', callBack, time)
        setTimeout(callBack, time);
    }


    /**
     * @description Builds a link targeting the given controller and action with the query string specified
     * @param controller {string}
     * @param action {string}
     * @param params {key, value} example: {param1: testValue, param2: testValue}
     * @param debugIt {boolean} Prints all given arguments
     * @returns {string}
     */
    var createLink = function (controller, action, params, debugIt) {
        if(debugIt) console.log("helperFacotry.createLink", {controller: controller, action: action, params: params})
        let link = WEBAPP_PATH + '/' + controller + '/' + action
        const queryString = Object.entries(params)
        if(queryString.length) link = link.concat('?')
        for(var item in queryString) {
            link = link.concat(item['key'] + '=' + item['value'] + '&')
        }
        return link.slice(0, -1)
    }

    /**
     * @description format given number to given decimal places
     * @param {number} number 
     * @param {number} decimalPlaces 
     * @param {boolean} debugIt 
     * @returns {number}
     */
    var formatNumber = function(number, decimalPlaces, debugIt) {
        if(debugIt)console.log("helperFactory.formatNumber", number, decimalPlaces);
        return number.toFixed(decimalPlaces)
    }

    /**
     * @description alternative to 'newDate' above - does not alter the string argument resolving date being returned null if passed a valid ISO date string
     * @param {string} date 
     * @returns {Date}
     */
    var createDate = function(date) {
        return new Date(date);
    }

    var getSelectedValuesCount = function(object){
      
      let data = object;
      let count = 0;
      angular.forEach(data, function(item) {
        if (item.value === true) {
          count++;
        }
      });
      
      return count;

    }

    var removeByValueFromList = function(object, value) {
      var index = object.indexOf(value);
        if (index !== -1) {
          object.splice(index, 1);
        }
        return object;
    };


  return {
        debug:              debug,
        copyByVal:          copyByVal,
        mergeArraysUnique:  mergeArraysUnique,
        removeFromArray:    removeFromArray,
        countProps:         countProps,
        countProp:          countProp,
        newDate:            newDate,
        copyListFieldWithValue: copyListFieldWithValue,
        dateAddSubtractDays: dateAddSubtractDays,
        dateAddSubstractDays: dateAddSubtractDays, //deprecated mispelt support
        roundNumberDown: roundNumberDown,
        roundNumber: roundNumber,
        filterList: filterList,
        getElementArrayLength: getElementArrayLength,
        getCostCodes: getCostCodes,
        reduceList: reduceList,
        validateCostCode2: validateCostCode2,
        triggerElementEvent: triggerElementEvent,
        getObjectPropertiesLength : getObjectPropertiesLength,
        joinObjectProperties : joinObjectProperties,
        joinObjectPropertiesClone: joinObjectPropertiesClone,
        cloneDeep: cloneDeep,
        removePropertiesOfObjectFromAnother: removePropertiesOfObjectFromAnother,
        hasValue: hasValue,
        encodeURLComponent: encodeURLComponent,
        allValuesSelected:allValuesSelected,
        setAllValuesForGivenProperty: setAllValuesForGivenProperty,
        someForAllGivenProperties: someForAllGivenProperties,
        timeout: timeout,
        createLink: createLink,
        formatNumber: formatNumber,
        createDate: createDate,
        getSelectedValuesCount: getSelectedValuesCount,
        removeByValueFromList: removeByValueFromList
    };
});